import {AxiosResponse} from "axios"
import {ICompany, IStandardPagedResponse} from "../types";
import {ICompanyDTO} from "../types/dtos/ICompanyDTO";
import {apiClient, RetryConfig, createRetryingNotificationHandler} from "./apiClient"


export const loadCompanies = async (): Promise<Array<ICompany>> => {
    const url = "/companies"
    const response: AxiosResponse<IStandardPagedResponse<ICompanyDTO>> = await apiClient.get(url,
        {
            retry: true,
            maxRetries: 100,
            backoff: 300,
            onRetry: createRetryingNotificationHandler({message:"Loading Companies Failed."})
        } as RetryConfig)
    return response.data.data.map((companyDTO) => {
        return {
            id: companyDTO.id,
            name: companyDTO.name,
            createdAt: companyDTO.created_at
        } as ICompany
    })
}